import { GridContainer, H3, Icon, Row, SelectionSet } from '@vp/swan';
import { __ } from '@99designs/i18n';
import { CompareOptions } from './CompareOptions/CompareOptions';
import { SelectionInput } from './SelectionInput';
import { VideoHelpIcon } from './VideoHelpIcon';

export type ReviewMethodProps = {
    reviewMethod: string;
    setReviewMethod: (reviewMethod: string) => void;
};

export function ReviewMethod({ reviewMethod, setReviewMethod }: ReviewMethodProps) {
    return (
        <div>
            <H3 fontSkin="title-subsection" id="review-method-selection">
                {__('Choose your review method')}
            </H3>
            <SelectionSet
                variant="single-select"
                selectedValue={reviewMethod}
                onSelectedValueChange={(value) => setReviewMethod(value ?? reviewMethod)}
                mb={4}
            >
                <GridContainer>
                    <Row marginTop={5}>
                        <SelectionInput
                            title={__('Review online in your own time')}
                            value="Standard"
                            icon={() => <Icon iconType="mail" size="standard" />}
                        />

                        <SelectionInput
                            title={__('Schedule a live video call')}
                            value="DesignLive"
                            icon={() => <VideoHelpIcon />}
                        />
                    </Row>
                </GridContainer>
            </SelectionSet>
            <CompareOptions />
        </div>
    );
}
